import { useAuth } from 'react-oidc-context';
import AppContext from '../../AppContext';
import { useEffect,useContext,useState/*,useRef*/ } from 'react';
import ContinueBox from './boxes/continue';
import PromoX1Box from './boxes/promoX1';
import RequestCopyBox from './boxes/requestCopy';
import YourProductsBox from './boxes/yourProd';
import { useNavigate } from 'react-router-dom';
import './dash.css';
import BooksForYou from './boxes/BooksForYou';
import RivisteForYou from './boxes/RivisteForYou';
import CorsiForYou from './boxes/CorsiForYou';
import {uscall,getfirst} from '../../us';
import UserContext from '../../UserContext';
import CommonContext from '../../CommonContext';

export default function Dashboard({reloadusercontext}) {
    const auth = useAuth();
    let navigate = useNavigate();
    const appcontext = useContext(AppContext);
    const usercontext = useContext(UserContext);
        const commoncontext = useContext(CommonContext);
    useEffect(() => {
      if(auth.isAuthenticated);
      else 
        navigate('/login/?redirect='+encodeURIComponent(document.location.href));
    },[auth,navigate]);
    const [curuser,setCurUser]=useState(null);
    const [lastBuy,setLastBuy]=useState(null);
    const [lastProduct,setLastProduct]=useState(null);
	const [producttypes,setProductTypes]=useState(null);
	const [edusource,setEduSource]=useState(null);
    const [box1,setBox1]=useState(null);
    const [box2,setBox2]=useState(null);
    useEffect(() => {
	const cb=async function(){
		setProductTypes(commoncontext.producttypes);
	}
	if(producttypes);else if(commoncontext && commoncontext.producttypes)
		cb();
    },[auth,appcontext,commoncontext,producttypes]);
    useEffect(() => {
	const loadLastLocalOrder=async function(){
		let r2=await uscall(appcontext,auth,'order','order','myactiveorders',null,{sort:{field:'committed',desc:true},limit:2});
		if(r2.result.length>0){
		let status_tbl=[];
		for(let i=0;i<r2.result.length;i++){if(status_tbl.includes(r2.result[i].status));else status_tbl.push(r2.result[i].status);}
		let statuses=await uscall(appcontext,auth,'order','orderstatus','load',null,status_tbl);
		let items_tbl=[];
		for(let i=0;i<r2.result.length;i++)items_tbl=items_tbl.concat(r2.result[i].items);
		let items=await uscall(appcontext,auth,'order','orderitem','load',null,items_tbl);
		let products_tbl=[];
		for(let i in items.result)products_tbl.push(items.result[i].product);
		let products=await uscall(appcontext,auth,'pim','product','load',null,products_tbl);

		for(let i=0;i<r2.result.length;i++){
			let myitems=[];
			for(let j=0;j<r2.result[i].items.length;j++){
				let item=items.result[r2.result[i].items[j]];
				item.product=products.result[item.product];
				myitems.push(item);
			}
			r2.result[i].status=statuses.result[r2.result[i].status].code;
			r2.result[i].items=myitems;
			return r2.result[i];
		}
		}
		return null;
	};
	const loadLastRemoteOrder=async function(){
		const r=await uscall(appcontext,auth,'ecommerce',null,'order_getlastuserorder',null,null);
//console.log('lastorder:'+JSON.stringify(r));
		if(typeof(r['error'])!='undefined');
		else if(typeof(r['result'])!='undefined' && r.result){
			return r.result;
			//for(let i=0;i<r.result.length;i++){
			//	return r.result[i];
			//}
		}
		return null;
	};
	const cb=async function(){
		const l1=await loadLastLocalOrder();
		let canbesetl1=false;
		if(l1){
			for(let i=0;i<l1.items.length;i++){
				if(l1.items[i].product && typeof(l1.items[i].product['code'])!='undefined' && l1.items[i].product.code=='abbonamentoedu')continue;//canbesetl1=false;
				//if(canbesetl1){
					setLastBuy(l1);// abbonamentoedu cannot be the last buy
					canbesetl1=true;
					break;
			//	}
			}
			
		}
		const l2=await loadLastRemoteOrder();
//console.log(l1);
		if(l2 && ((!l1) || (!canbesetl1) || l2.created>l1.created)){
			setLastBuy(l2);
		}

		/*const r=await uscall(appcontext,auth,'ecommerce',null,'order_getlastuserorder',null,null);
//console.log('lastorder:'+JSON.stringify(r));
		if(typeof(r['error'])!='undefined');
		else if(typeof(r['result'])!='undefined' && r.result)setLastBuy(r.result);*/
	}
	if(lastBuy);else if(auth && auth.isAuthenticated && (!auth.isLoading) && (!auth.error) && auth.user && auth.user.access_token && usercontext && usercontext.user)
		cb();
    },[auth,appcontext,usercontext,lastBuy]);
    useEffect(() => {
	const cb=async function(){
		if(lastBuy && typeof(lastBuy['items'])!='undefined'){
			for(let i=0;i<lastBuy.items.length;i++){
				if(lastBuy.items[i].product){
					if(typeof(lastBuy.items[i].product['uuid'])=='undefined'){
						if(typeof(lastBuy.items[i].product['magento_custom'])!='undefined' && typeof(lastBuy.items[i].product.magento_custom['isbn'])!='undefined'){
							const r=getfirst(await uscall(appcontext,auth,'ecommerce',null,'product_search',null,{filter:{field:'isbn',func:'eq',value:lastBuy.items[i].product.magento_custom.isbn},limit:1}));
							if(r && typeof(r['uuid'])!='undefined')
								lastBuy.items[i].product.uuid=r.uuid;
						}
					}else{
						if(typeof(lastBuy.items[i].product['copertina'])!='undefined' && lastBuy.items[i].product.copertina){
						}else if(typeof(lastBuy.items[i].product['masterproduct'])!='undefined' && lastBuy.items[i].product.masterproduct){
							const pp=getfirst(await uscall(appcontext,auth,'pim','product','load',null,[lastBuy.items[i].product.masterproduct]));
							if(pp && typeof(pp['copertina'])!='undefined')
								lastBuy.items[i].product.copertina=pp.copertina;
						}
					}

					setLastProduct(lastBuy.items[i].product);
					break;
				}
			}
		}
	};
	cb();
	},[lastBuy]);

    //const effectRan = useRef(false);// use to avoid in dev mode double rendering after redirect, causing NS_BINDING_ERR: 

    useEffect(() => {
	const checkPrimoAccesso=async function(){
		//const tokeninfo=(await uscall(appcontext,auth,'aaa','session','tokeninfo',null,null));
		//if(tokeninfo);else return;
		//const user=getfirst(await uscall(appcontext,auth,'aaa','user','load',null,[tokeninfo.user]));
		const user=usercontext.user;
		if(user.professione);else return navigate('/profilo/primoaccesso/');
		user.professionecode=getfirst(await uscall(appcontext,auth,'pim','professione','load',null,[user.professione])).code;
		setCurUser(user);
		setEduSource(usercontext.edu_source);
	};
	//if(!effectRan.current){
	if(usercontext && usercontext.user)
		checkPrimoAccesso();
	//	return () => effectRan.current = true;
	//}
    }, [appcontext,auth,usercontext,navigate]);

    useEffect(() => {
	const checkfornewbundles=async()=>{
		const r=await uscall(appcontext,auth,'ecommerce',null,'order_checkbundlepremium',null,null);
		if(typeof(r['error'])!='undefined');
		else if(typeof(r['result'])!='undefined' && r.result){
			if(reloadusercontext)reloadusercontext();
			//document.location.href='/dashboard/';//reload
		}
	};
	if(usercontext && usercontext.user)
		checkfornewbundles();
    }, [appcontext,auth,usercontext,navigate]);


    useEffect(() => {
	const hasedu=(curuser && curuser.has_edu_upto && curuser.has_edu_upto>(new Date()).valueOf() && edusource);
	let box1areacode=(curuser?(curuser.professionecode==='student'?'dashboard_'+(hasedu?'edu_':'')+'studenti_top_right':(curuser.professionecode==='professor'?'dashboard_'+(hasedu?'edu_':'')+'docenti_top_right':'dashboard_'+(hasedu?'edu_':'')+'professionisti_top_right')):null)+(hasedu && edusource && edusource=='code'?'_bundlestandard':'');
	setBox1(box1areacode);
	let box2areacode=(curuser?(curuser.professionecode==='student'?'dashboard_'+(hasedu?'edu_':'')+'studenti_left':(curuser.professionecode==='professor'?'dashboard_'+(hasedu?'edu_':'')+'docenti_left':'dashboard_'+(hasedu?'edu_':'')+'professionisti_left')):null)+(hasedu && edusource && edusource=='code'?'_bundlestandard':'');
	setBox2(box2areacode);
    }, [curuser,edusource]);

    return (
	<>
	{ auth.isAuthenticated ? (

        <div className='dash-container'>
            <div className='row g-0 mb-md-4'>
                <div className='col-md-6 col-lg-8 mb-4 mb-md-0'>
                  <ContinueBox key={lastProduct} lastProduct={lastProduct} professionecode={curuser?curuser.professionecode:null} producttypes={producttypes} />
				</div>
                <div className='col-md-6 col-lg-4 mb-4 mb-md-0'>
	                  <PromoX1Box areacode={box1} />
				</div>
            </div>
		{lastBuy?(
            <div className='row g-0 mb-md-4'>
                <div className='col-md-6 col-lg-4 mb-4 mb-md-0'>
	                  <PromoX1Box areacode={box2} />
				</div>
                <div className='col-md-6 col-lg-8 mb-4 mb-md-0'>
                  <YourProductsBox />
				</div>
            </div>):(<></>)}
            <div className='row g-0 mb-md-4'>
		{curuser && curuser.professionecode?(
		<>
	                <RequestCopyBox areacode={curuser.professionecode==='student'?'dashboard_studenti_1':(curuser.professionecode==='professor'?'dashboard_docenti_1':'dashboard_professionisti_1')} />
	                <RequestCopyBox areacode={curuser.professionecode==='student'?'dashboard_studenti_2':(curuser.professionecode==='professor'?'dashboard_docenti_2':'dashboard_professionisti_2')} />
	                <RequestCopyBox areacode={curuser.professionecode==='student'?'dashboard_studenti_3':(curuser.professionecode==='professor'?'dashboard_docenti_3':'dashboard_professionisti_3')} />
	                <RequestCopyBox areacode={curuser.professionecode==='student'?'dashboard_studenti_4':(curuser.professionecode==='professor'?'dashboard_docenti_4':'dashboard_professionisti_4')} />
		</>
		):''}
            </div>
		<>{curuser && (
            <div className='row g-0'>
                <div className='col-12 mb-4'>
                  <BooksForYou professionecode={curuser.professionecode} />
		</div>
            </div>)}</>
		<>{curuser && curuser.professionecode && curuser.professionecode!=='student' && (
            <div className='row g-0'>
                <div className='col-12 mb-4'>
                  <RivisteForYou />
		</div>
            </div>
		)}</>
		<>{curuser && curuser.professionecode && curuser.professionecode!=='professor' && (
            <div className='row g-0'>
                <div className='col-12 mb-4'>
                  <CorsiForYou />
		</div>
            </div>
		)}</>
        </div>
	):(<></>)}
	</>

    )

};

